/* eslint-disable */
import { hiprint } from 'vue-plugin-hiprint'

/**
 * 条码标签打印模板 - 设计元素提供器
 * 提供拖拽设计时可用的元素类型
 */
export const labelProvider = function (ops) {
  var addElementTypes = function (context) {
    context.removePrintElementTypes("labelProviderModule");
    context.addPrintElementTypes(
      "labelProviderModule",
      [
        new hiprint.PrintElementTypeGroup("预设", [
          {
            tid: 'labelProviderModule.itemNo',
            title: '货号',
            data: '货号',
            type: 'text',
            options: {
              field: 'ItemNo',
              testData: '货号',
              height: 12,
              ontSize: 10,
              width: 50,
              fontWeight: "400",
              textAlign: "left",
            }
          },
          {
            tid: 'labelProviderModule.color',
            title: '颜色',
            data: '颜色',
            type: 'text',
            options: {
              field: 'Color',
              testData: '颜色',
              height: 12,
              ontSize: 10,
              width: 50,
              fontWeight: "400",
              textAlign: "left",
            }
          },
          {
            tid: 'labelProviderModule.size',
            title: '尺码',
            data: '尺码',
            type: 'text',
            options: {
              field: 'Size',
              testData: '尺码',
              height: 12,
              ontSize: 10,
              width: 50,
              fontWeight: "400",
              textAlign: "left",
            }
          },
          // {
          //   tid: 'labelProviderModule.specName',
          //   title: '规格名称',
          //   data: '规格名称',
          //   type: 'text',
          //   options: {
          //     field: 'SpecName',
          //     testData: '规格名称',
          //     height: 12,
          //     ontSize: 10,
          //     width: 50,
          //     fontWeight: "400",
          //     textAlign: "left",
          //   }
          // },
          {
            tid: 'labelProviderModule.barcodetype',
            title: '条形码',
            type: 'barcode',            
            options: {
              field: 'Barcode',
              width:  80,
              height: 40,
              textAlign: "left",
            }
          },
          {
            tid: 'labelProviderModule.qrcodetype',
            title: '二维码',
            type: 'qrcode',
            options: {
              field: 'Barcode',
              hideTitle: true,
              width:  50,
              height: 50,
              textAlign: "left",
            }
          },
        ]),
        new hiprint.PrintElementTypeGroup("辅助", [
          {
            tid: 'labelProviderModule.hline',
            title: '横线',
            type: 'hline',
            options: {
              borderWith: 1,
            }
          },
          {
            tid: 'labelProviderModule.vline',
            title: '竖线',
            type: 'vline',
            options: {
              borderWith: 1,
            }
          },          
          {
            tid: 'labelProviderModule.text',
            title: '文本',
            customText: '自定义文本',
            custom: true,
            type: 'text',
            options: {
              fontSize: 7,
            }
          },
          {
            tid: 'labelProviderModule.longText',
            title: '长文本',
            type: 'longText',
            options: {
              width: 100,
              testData: '长文本测试',
              fontSize: 7,
              hideTitle: true,
              textAlign: "left",
            },
          },
          {
            tid: 'labelProviderModule.rect',
            title: '矩形',
            type: 'rect',
            options: {
              width:  50,
              height: 50,
              borderWith: 1,
              borderColor: '#000',
            }
          },
          {
            tid: 'labelProviderModule.oval',
            title: '椭圆',
            type: 'oval',
            options: {
              width:  20,
              height: 20,
              borderWith: 1,
              borderColor: '#000',
            }
          }
        ])
      ]
    );
  };
  return {
    addElementTypes: addElementTypes
  };
};

// 左侧面板卡片数据（供自定义渲染使用）
export const   dragGroups = [
        {
          title: '预设',
          items: [
            { tid: 'labelProviderModule.itemNo', title: '货号', icon: 'ri-hashtag' },
            { tid: 'labelProviderModule.color', title: '颜色', icon: 'ri-palette-line' },
            { tid: 'labelProviderModule.size', title: '尺码', icon: 'ri-ruler-line' },
            { tid: 'labelProviderModule.barcodetype', title: '条形码', icon: 'ri-barcode-line' },
            { tid: 'labelProviderModule.qrcodetype', title: '二维码', icon: 'ri-qr-code-line' },
          ],
        },
        {
          title: '辅助',
          items: [
            { tid: 'labelProviderModule.text', title: '文本', icon: 'ri-text' },
            { tid: 'labelProviderModule.longText', title: '长文本', icon: 'ri-align-left' },
            { tid: 'labelProviderModule.vline', title: '竖线', icon: 'ri-subtract-line', iconRotate: 90 },
            { tid: 'labelProviderModule.hline', title: '横线', icon: 'ri-subtract-line' },
            { tid: 'labelProviderModule.rect', title: '矩形', icon: 'ri-checkbox-blank-line' },
            { tid: 'labelProviderModule.oval', title: '椭圆', icon: 'ri-checkbox-blank-circle-line' },
          ],
        },
      ];

export default [{
  name: '条码标签设计',
  value: 'labelProviderModule',
  type: 1,
  f: labelProvider(), dragGroups
}]
